exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body{font-family:Times New Roman,SourceHanSansSC,sans-serif;width:100%;height:100%;overflow-y:scroll;overflow-x:hidden}.m-0-auto{margin:0 auto}.m-0{margin:0}.m-r-5{margin-right:.026042rem}.m-t-5{margin-top:.026042rem}.p-0{padding:0}.w-100pct{width:100%}.no-image img{display:none}.no-content{text-align:center;width:100%;height:.520833rem;line-height:.520833rem;color:#666}a:hover{color:inherit}.pointer{cursor:pointer}.viewer-backdrop{background-color:rgba(0,0,0,.8)}@font-face{font-family:SourceHanSansSC;src:url(" + require("../fonts/SourceHanSansSC-Regular-2.otf") + ")}@font-face{font-family:Times New Roman;src:url(" + require("../fonts/times.ttf") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/assets/css/common.css
// module id = 926
// module chunks = 0